import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store"
import ElementUI from 'element-ui'
import moment from 'moment'
import global from '@/global'
import config from '@/config'

/*import {Button, Select} from 'element-ui'*/
import 'element-ui/lib/theme-chalk/index.css'

router.beforeEach((to, from, next) => {
    var top = document.body.scrollTop || document.documentElement.scrollTop;
    if (document.body.scrollTop != 0) {
        document.body.scrollTop -= top;
    } else {
        document.documentElement.scrollTop -= top;
    }
    //最后通过钩子继续页面的跳转
    next();
});

Vue.config.productionTip = false

// 全部使用
Vue.use(ElementUI)
//Vue.use(ElementUI, {size: 'small'})
/*
// 部分引用
Vue.component(Button.name, Button)
Vue.component(Select.name,Select)
Vue.use(Button)
Vue.use(Select)
*/
Vue.prototype.$moment = moment
Vue.filter('datetime', function (value) {
    if (!value) return ''
    value = value.toString()
    let format = 'YYYY-MM-DD'
    return moment(value).format(format)
})
// Vue.filter('datetime1', function (value) {
//     if (!value) return ''
//     value = value.toString()
//     let format = 'YYYY-MM-DD HH:MM'
//     return moment(value).format(format)
// })
Vue.filter('datetime2', function (value) {
    if (!value) return ''
    value = value.toString()
    let format = 'YYYY-MM-DD HH:MM:SS'
    return moment(value).format(format)
})
Vue.filter('datemunite', function (value) {
    if (!value) return ''
    var date = new Date(value)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let minute = date.getMinutes()
    if (month >= 1 && month <= 9) { month = `0${month}` }
    if (day >= 1 && day <= 9) { day = `0${day}` }
    if (hour >= 0 && hour <= 9) { hour = `0${hour}` }
    if (minute >= 0 && minute <= 9) { minute = `0${minute}` }
    
    return `${year}-${month}-${day} ${hour}:${minute}`;
})
Vue.filter('year', function (value) {
    if (!value) return ''
    value = value.toString()
    let format = 'YYYY'
    return moment(value).format(format)
})
Vue.filter('month', function (value) {
    if (!value) return ''
    value = value.toString()
    let format = 'MM-DD'
    return moment(value).format(format)
})

Vue.filter('mobileNumFilter', function (value) {
    if (value) {
        let start = value.slice(0, 3);
        let end = value.slice(-4);
        return `${start}****${end}`;
    }
})

Vue.filter('certNumFilter', function (value) {
    if (value) {
        if (value.length == 18) {
            let start = value.slice(0, 6);
            let end = value.slice(-4);
            return `${start}********${end}`;
        } else if (value.length == 15) {
            let start = value.slice(0, 6);
            let end = value.slice(-3);
            return `${start}******${end}`;
        } else {
            let star = ''
            for (var i = 0; i < value.length - 4; i++) {
                star += '*'
            }
            let start = value.slice(0, 4);
            return `${start}${star}`;
        }
    } else {
        return value
    }
})


/**
 * 全局变量枚举
 */
Vue.prototype.$Global = global

/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config

// 路由跳转前执行
// router.beforeEach((to, from, next) => {
//   // 页面置顶
//   document.body.scrollTop = 0
//   // firefox
//   document.documentElement.scrollTop = 0
//   // safari
//   window.pageYOffset = 0

//   next();
// })


new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')